import React, { useState } from 'react';
import { 
  X, 
  Sparkles,
  ChevronRight,
  Grid
} from 'lucide-react';
import { AI_APPS } from '../constants/aiApps';

const AIAppsWidget = ({ onSelectApp, onOpenFullView }) => {
  const [isExpanded, setIsExpanded] = useState(false); // Collapsed by default
  const [isVisible, setIsVisible] = useState(true);

  // Show first 6 apps in the widget
  const quickApps = AI_APPS.slice(0, 6);

  // Early return after all hooks are defined
  if (!isVisible) return null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden transition-all duration-300">
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-700 dark:to-gray-700 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-gradient-to-r from-blue-500 to-purple-500 p-2 rounded-lg text-white">
              <Sparkles className="w-5 h-5" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white">
                AI Assistants
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Specialized tools for every task
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="p-1.5 hover:bg-white/50 dark:hover:bg-gray-600 rounded-lg transition-colors"
              title={isExpanded ? "Collapse" : "Expand"}
            >
              <ChevronRight 
                className={`w-4 h-4 text-gray-600 dark:text-gray-400 transition-transform ${
                  isExpanded ? 'rotate-90' : ''
                }`} 
              />
            </button>
            <button
              onClick={() => setIsVisible(false)}
              className="p-1.5 hover:bg-white/50 dark:hover:bg-gray-600 rounded-lg transition-colors"
              title="Close widget"
            >
              <X className="w-4 h-4 text-gray-600 dark:text-gray-400" />
            </button>
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
            {quickApps.map((app) => (
              <button
                key={app.id}
                onClick={() => {
                  if (onSelectApp) {
                    // Directly call onSelectApp without showing expanded view
                    onSelectApp({
                      ...app,
                      metadata: {
                        ...app,
                        icon: undefined,
                        options: {}
                      }
                    });
                  }
                }}
                className="group flex flex-col items-center gap-2 p-3 rounded-lg border border-gray-200 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200"
              >
                <div className={`${app.color} p-2 rounded-lg text-white group-hover:scale-110 transition-transform`}>
                  <app.icon className="w-4 h-4" />
                </div>
                <div className="text-center">
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {app.name}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {app.description}
                  </div>
                </div>
              </button>
            ))}
          </div>

          <button
            onClick={onOpenFullView}
            className="w-full flex items-center justify-center gap-2 p-2.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            <Grid className="w-4 h-4" />
            View All Assistants
          </button>
        </div>
      )}
    </div>
  );
};

export default AIAppsWidget;